import { Cookies } from 'react-cookie';

import { UserUpdateFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface putUserPageDataProps {
  id?: number;
  userData: UserUpdateFormValues;
}

export const putUserPageData = async (info: putUserPageDataProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.patch(
    `/users/${info.id}/`,
    {
      ...info.userData,
    },
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data.data as any;
};
